if (!customElements.get('shop-the-look')) {
  customElements.define(
    'shop-the-look',
    class ShopTheLook extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        this.abortController = new AbortController();
        const { signal } = this.abortController;

        this.hotspots = Array.from(this.querySelectorAll('[data-hotspot-index]'));
        this.products = Array.from(this.querySelectorAll('[data-product-index]'));
        this.drawer = this.querySelector('.shop-the-look__drawer');
        this.index = 0;

        this.addEventListener('click', this.onClick.bind(this), { signal });

        if (Shopify.designMode) {
          document.addEventListener(
            'shopify:block:select',
            (event) => {
              if (event.detail.sectionId != this.dataset.sectionId) return;
              this.select(Number(event.target.dataset.hotspotIndex));
            },
            { signal }
          );
        }
      }

      disconnectedCallback() {
        this.abortController?.abort();
      }

      onClick(event) {
        const hotspot = event.target.closest('[data-hotspot-index]');
        if (hotspot) {
          // Below the split layout (1024px) the products live in a bottom drawer
          if (FoxTheme.config.mqlTablet) {
            this.drawer && this.drawer.show(hotspot);
            return;
          }
          this.select(Number(hotspot.dataset.hotspotIndex));
          return;
        }

        const control = event.target.closest('[data-step]');
        if (control) this.select(this.index + Number(control.dataset.step));
      }

      select(index) {
        const total = this.hotspots.length;
        if (!total || Number.isNaN(index)) return;

        this.index = ((index % total) + total) % total;

        this.hotspots.forEach((element, i) => {
          element.classList.toggle('is-active', i === this.index);
          element.setAttribute('aria-current', i === this.index ? 'true' : 'false');
        });

        this.products.forEach((element, i) => {
          element.classList.toggle('is-selected', i === this.index);
        });
      }
    }
  );
}
